import { render, staticRenderFns } from "./messageInstruction.vue?vue&type=template&id=028475d0&scoped=true&"
import script from "./messageInstruction.vue?vue&type=script&lang=js&"
export * from "./messageInstruction.vue?vue&type=script&lang=js&"
import style0 from "./messageInstruction.vue?vue&type=style&index=0&id=028475d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028475d0",
  null
  
)

export default component.exports